<template>
  <v-card flat tile>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-text-field
          v-model="form.title"
          name="title"
          counter="65"
          :label="`${$t('ITEM.TITLE')} *`"
          outlined
          :readonly="readonly"
          :error-messages="errors.title"
          :rules="getRulesByName('title')"
          @input="updateValue('title', $event)"
        />
      </v-col>

      <v-col cols="12" class="pt-0">
        <url-languages-form
          v-model="form"
          :readonly="readonly"
          :errors="errors"
          @input="emitter"
          @update-prop="updateProp(...arguments)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { requiredTextLine65 } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';
import UrlLanguagesForm from '@/modules/documents_links/components/forms/UrlLanguagesForm';

export default {
  name: 'DocumentsLinkForm',

  components: {
    UrlLanguagesForm
  },

  mixins: [formEditable],

  data() {
    return {
      form: {
        title: null
      },
      rules: {
        title: requiredTextLine65
      }
    };
  }
};
</script>
